var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-dropdown",
        {
          staticClass: "mr-2",
          attrs: { size: "sm", variant: "outline-primary", right: "" },
          scopedSlots: _vm._u([
            {
              key: "button-content",
              fn: function () {
                return [
                  _c("span", [
                    _c("i", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          value: {
                            title: _vm.$t("message.external_references"),
                          },
                          expression:
                            "{ title: $t('message.external_references') }",
                          modifiers: { hover: true },
                        },
                      ],
                      staticClass: "fa fa-link",
                    }),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        _vm._l(_vm.externalReferences, function (r) {
          return _c(
            "b-dropdown-item",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  value: { placement: "left", title: r.url },
                  expression: "{ placement: 'left', title: r.url }",
                  modifiers: { hover: true },
                },
              ],
              key: r.url,
              attrs: { target: "_blank", href: r.url },
            },
            [
              _c("i", { staticClass: "fa fa-external-link text-muted" }),
              _vm._v(" \n      "),
              _vm.typeAcronyms.includes(r.type)
                ? _c("span", { staticClass: "text-uppercase" }, [
                    _vm._v(_vm._s(r.type)),
                  ])
                : _c("span", { staticClass: "text-capitalize" }, [
                    _vm._v(_vm._s(r.type)),
                  ]),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }